import {
  dayMonthDateString,
  Shift,
  shiftTimeRangeDurationString,
} from '@nextforce/api'
import { Divider, makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'
import { UserAvatar } from 'shared/components/user/user_avatar'

interface Props {
  shift: Shift
}
export function UserShiftCard({ shift }: Props) {
  const styles = useStyles()
  return (
    <View style={styles.card}>
      <Text style={styles.date}>
        {dayMonthDateString(shift.date)} {` (${shift.store.storeNumber})`}
      </Text>
      <Text style={styles.time}>{shiftTimeRangeDurationString(shift)}</Text>
      <Text style={styles.shiftPosition}>
        {shift.position ?? t('anyPosition')}
      </Text>
      {shift.user?.firstName && (
        <View>
          <Divider style={styles.divider} />
          <View style={styles.userContainer}>
            <UserAvatar user={shift.user} size="medium" />
            <Text
              style={styles.name}
            >{`${shift.user?.firstName} ${shift.user?.lastName}`}</Text>
          </View>
        </View>
      )}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: theme.colors?.grey5,
  },

  card: {
    justifyContent: 'center',
    backgroundColor: theme.colors?.white,
    shadowColor: theme.colors?.black,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,

    marginBottom: 17,
    padding: 10,
  },

  date: {
    fontSize: 19,
    fontFamily: font.bold,
    marginBottom: 10,
  },
  time: {
    fontSize: 16,
    color: theme.colors?.grey1,
  },

  shiftPosition: {
    fontSize: 17,
    marginVertical: 10,
  },

  name: {
    margin: 10,
    fontFamily: font.bold,
    fontSize: 19,
  },
  userContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 10,
  },
  divider: {
    backgroundColor: theme.colors?.grey0,
    width: '100%',
  },
}))
